import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ScorecardService } from 'shared/scorecard/scorecard.service';
import { BrandService } from 'shared/brand/brand.service';


@Component({
  moduleId: module.id,
  selector: 'dashboard-scorecard',
  templateUrl: 'dashboard-scorecard.component.html',
  styleUrls: ['dashboard-scorecard.component.scss'],
})
export class DashboardScorecardComponent implements OnInit {
  scorecardsList: Array<any> = [];

  constructor(
    private scorecardService: ScorecardService,
    private brandService: BrandService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.scorecardService.getCatalogTotalScores(this.brandService.getBrand(), 'working')
    .subscribe((scorecards: Array<any>) => {
      this.scorecardsList = scorecards;
    });
  }

  onScoreClick(scorecard: any) {
    this.router.navigate(['my-products/working', { selectedScorecard: scorecard._id }]);
  }
}
